import React, { useEffect, useRef, useState } from "react";
import Styles from "./SliderLayout.module.css";

enum SlideDirection {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

const scrollDistance = 300;

const Slider = ({ children }: React.PropsWithChildren) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const [showSlider, setShowSlider] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies(scrollContainerRef.current?.scrollWidth): TODO: [User Story 20223: Address `useExhaustiveDependencies` Biome issues](https://hoylu.visualstudio.com/production/_workitems/edit/20223)
  useEffect(() => {
    if (!scrollContainerRef.current?.parentElement?.clientWidth) return;

    setShowSlider(
      scrollContainerRef.current.scrollWidth >
        scrollContainerRef.current?.parentElement?.clientWidth,
    );
  }, [scrollContainerRef.current?.scrollWidth]);

  const scroll = (command: SlideDirection) => {
    const direction =
      command === SlideDirection.LEFT ? -scrollDistance : scrollDistance;

    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: direction,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const container = scrollContainerRef.current;

      if (container) {
        setShowLeftArrow(container.scrollLeft !== 0);
        setShowRightArrow(
          container.scrollLeft + container.clientWidth < container.scrollWidth,
        );
      }
    };

    const container = scrollContainerRef.current;

    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
    return undefined;
  }, []);

  return (
    <div className={Styles.sliderLayout}>
      <div className={Styles.templates} ref={scrollContainerRef}>
        {React.Children.map(children, (child, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: TODO: Improve logic to avoid using Array index.
          <div className={Styles.template} key={index}>
            {child}
          </div>
        ))}
      </div>
      {showLeftArrow && (
        <div
          className={`${Styles.navigation} ${Styles.left}`}
          onClick={() => scroll(SlideDirection.LEFT)}
        >
          <span className={Styles.arrow}>&lt;</span>
        </div>
      )}
      {showRightArrow && showSlider && (
        <div
          className={`${Styles.navigation} ${Styles.right} ${Styles.navigationShadow}`}
          onClick={() => scroll(SlideDirection.RIGHT)}
        >
          <span className={Styles.arrow}>&gt;</span>
        </div>
      )}
    </div>
  );
};

export default Slider;
